<template>
  <div>
    <div v-if="step == 'form'">
      <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
        <input type="text" v-on:keypress="isLetter($event)" class="form-control" v-model="contact.name" name="field1" placeholder="Ваше имя">
        <p class="help-block" v-if="errors.name">
          {{ errors.name.join(', ') }}
        </p>
      </div>
      <div class="form-group" v-bind:class="{ 'has-error': errors.email }">
        <input type="text" placeholder="Email, телефон или мессенджеры" class="form-control" v-model="contact.email" name="field2">
        <p class="help-block" v-if="errors.email">
          {{ errors.email.join(', ') }}
        </p>
      </div>

      <div class="form-group" v-bind:class="{ 'has-error': errors.quest }">
        <textarea rows="3" placeholder="Суть дела" type="text" class="form-control" v-model="contact.quest"></textarea>
        <p class="help-block" v-if="errors.email">
          {{ errors.email.join(', ') }}
        </p>
      </div>
      <div class="form-group text-center">
        <div class="form-group-submit-btn">
          <button class="btn btn-primary" v-on:click="sendForm" type="button">Отправить</button>
        </div>
      </div>
    </div>

    <div v-if="step == 'complete'">
      <p class="text-success">
        Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import FormMixin from '../vue_mixins/FormMixin.vue'


export default {
  name: 'FaqForm',
  mixins: [FormMixin],
  data() {
    return {
      contact: {},
      errors: {},
      step: 'form'
    }
  },
  mounted() {
    axios.get("/consult/api/faq/").then(response => {this.contact = response.data})
  },
  methods: {
    sendForm: function () {
      axios.put("/consult/api/faq/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
        ym(97921240,'reachGoal','CONTACT_MESSAGE');
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>

<style lang="scss">
</style>
